import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=0190721a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0190721a')) {
      api.createRecord('0190721a', component.options)
    } else {
      api.reload('0190721a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=0190721a&", function () {
      api.rerender('0190721a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eKj0yD3V9saX/JS/comp/IncreaseNumber.vue"
export default component.exports